import styled, {css, keyframes} from 'styled-components';
import {alignCenter, dFlex, dFlexColumn, justifyBetween} from '../../../../globalVariables/GlobalFlex';
import {StatusColor, statusStripPalette} from '../../StatusLabel/StatusLabel.css';

const qrPop = keyframes`
    0% { transform: scale(.6); opacity: .2; }
    60% { transform: scale(1.18); }
    100% { transform: scale(1); opacity: 1; }
`;

export const status = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    gap: var(--space-sm);
`;

export const caption = styled.span`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
`;

const pillLabelColor: Record<StatusColor, string> = {
    brand: 'var(--color-text-inverse-default)',
    highlight: 'var(--color-text-inverse-default)',
    scanned: 'var(--color-state-warning-main)',
    canceled: 'var(--primitive-red-600)',
    past: 'var(--primitive-black-40)',
};

export const pill = styled.span<{$color: StatusColor; $isPop?: boolean}>`
    ${dFlex}
    ${alignCenter}
    justify-content: center;
    gap: ${({$color}) => ($color === 'canceled' ? '0' : 'var(--space-sm)')};
    width: auto;
    height: 44px;
    padding: 0 var(--space-xl);
    border-radius: var(--border-radius-border-radius-full);
    overflow: hidden;
    background: ${({$color}) => statusStripPalette[$color].bg};
    box-shadow: none;
    ${p => p.$isPop && css`animation: ${qrPop} .5s cubic-bezier(.34, 1.56, .64, 1);`}
`;

export const label = styled.span<{$color: StatusColor}>`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-semibold);
    line-height: var(--line-height-body-small);
    color: ${({$color}) => pillLabelColor[$color]};
    transform: translateX(calc(var(--space-xs) * -1.5));
    white-space: nowrap;
`;

export const icon = styled.img<{$canceled?: boolean}>`
    display: block;
    width: 60px;
    height: 60px;
    flex: none;
    object-fit: contain;
    position: relative;
    top: var(--space-xs);
    transform: ${({$canceled}) => ($canceled ? 'rotate(13.998deg)' : 'none')};
`;

export const scanInfo = styled.div`
    ${dFlexColumn};
    gap: var(--space-sm);
    width: 100%;
    max-width: 260px;
`;

export const scanRow = styled.div`
    ${dFlex}
    ${justifyBetween}
    align-items: baseline;
    gap: var(--space-lg);
    font-size: var(--font-size-body);

    span:first-child {
        color: var(--color-text-subtle);
    }

    span:last-child {
        font-weight: var(--font-weight-medium);
        color: var(--color-text-default);
    }
`;
